<template>
  <validation-observer
    v-if="showHomeRenewal"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="home-renewal"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row :label="label">
        <v-row class="flex-column flex-sm-row">
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              :vid="`${stepId}_home-renewal`"
              name="Home Insurance Renewal"
              rules="listOptionRequired"
            >
              <qz-select
                v-model="questionData.homeRenewal"
                :data-test="snakeCase(questionFields.homeRenewal)"
                :items="options"
                :error-messages="errors"
                placeholder="Choose Month"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import HomeRenewal from '@/components/questions/HomeRenewal.vue';
import { inject } from '@vue/composition-api';

export default {
  name: 'question-home-renewal-split-testing',
  extends: HomeRenewal,
  computed: {
    options () {
      return [...this.monthsOptions, { value: 0, text: 'I don\'t know' }];
    },
    showHomeRenewal () {
      if (this.config.hideHomeRenewal) return false;
      if (this.isAdditional) return false;
      if (this.homeRenewalHomeOwnerNew) return true;

      return this.stepData?.residentialStatus === 'HO';
    },
  },
  created () {
    // revert variable on split test removal
    this.unwatchResidentialStatus();
  },
  setup () {
    const { homeRenewalHomeOwnerNew } = inject('abTastyControllerUI');

    return {
      homeRenewalHomeOwnerNew,
    };
  },
};
</script>
